import React, { Component } from "react";

class PromotionalValueAdjustments extends Component {
  constructor(props) {
    super(props);
    const languageData = JSON.parse(localStorage.getItem("languageData"));

    this.state = {
      globalLang: languageData.global,
      reportData: props.reportData ? props.reportData : [],
      languageData: languageData.business_insights,
    };

    window.onscroll = () => {
      return false;
    };
  }

  static getDerivedStateFromProps(nextProps) {
    let returnState = {};

    if (nextProps.reportData !== undefined) {
      returnState.reportData = nextProps.reportData;
    }

    return returnState;
  }

  fetchPromotionalClinicDetail = (
    promotionalClinicId,
    promotionalClinicName,
  ) => {
    if (promotionalClinicId !== undefined) {
      let returnState = {
        promotionalClinicId: promotionalClinicId,
        promotionalClinicName: promotionalClinicName,
      };
      this.props.fetchPromotionalClinicDetail(returnState);
    }
  };

  render() {
    const clinicAdjustments = this.state.reportData?.clinic_adjustments || [];

    return (
      <>
        <div className="table-responsive clients-table">
          <table className="table-updated setting-table table-min-width no-td-border">
            <thead className="table-updated-thead">
              <tr>
                <th className="table-updated-th">Clinic</th>
                <th className="table-updated-th">
                  Total Promotional Adjustments
                </th>
              </tr>
            </thead>
            <tbody className="ajax_body">
              {clinicAdjustments.length > 0 ? (
                clinicAdjustments.map((obj, idx) => {
                  return (
                    <tr
                      key={idx}
                      className="table-updated-tr"
                      onClick={this.fetchPromotionalClinicDetail.bind(
                        this,
                        obj.clinic_id,
                        obj.clinic_name,
                      )}
                    >
                      <td className="table-updated-td">{obj.clinic_name}</td>
                      <td className="table-updated-td">
                        {obj.total_adjustments}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr className="table-updated-tr">
                  <td
                    className="table-updated-td no-record no-float"
                    colSpan="10"
                  >
                    {this.state.languageData.bi_no_record_found}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </>
    );
  }
}

export default PromotionalValueAdjustments;
